<template>
  <ElDialog
    :title="$t('companySettings.billing.invoicePreview.youreAllSet')"
    v-on="$listeners"
    :visible="show"
    append-to-body
    @open="modalOpened"
  >
      <VLoadingSpinner v-if="loading" />
      <VForm :onSubmit="closeModal">
        <div slot="row">
          <VMessage
            class="messageMargin"
            type="success"
            :fullwidth="true">
            <template v-slot:icon>
              <CheckIcon />
            </template>
            <template v-slot:text>
              {{ successMessage }}
            </template>
          </VMessage>
        </div>
        <div slot="row">
          <p>
            <i18n path="companySettings.billing.invoicePreview.upgradeMessage" tag="span">
              <template v-slot:newPlan>
                <span>{{ selectedPlan.nickname }}</span>
              </template>
            </i18n>
            <i18n v-if="newPlanComparison.newFeatures.length" path="companySettings.billing.invoicePreview.yourNewFeatures" tag="span">
              <template v-slot:newFeatures>
                <span v-for="feature in newPlanComparison.newFeatures" :key="feature">
                <a
                    target="_blank"
                    :href="featureLinks[feature]"
                    data-ec="billing_plan_switch_success_modal"
                    :data-et="`plan_feature_link_${feature}`">
                  {{ $t(`companySettings.billing.plan.features.${feature}`) }}
                </a>
                <span v-if="newPlanComparison.newFeatures.length > 1 && feature !== newPlanComparison.newFeatures[newPlanComparison.newFeatures.length - 2] && feature !== newPlanComparison.newFeatures[newPlanComparison.newFeatures.length - 1]">, </span>
                <span v-if="newPlanComparison.newFeatures.length > 1 && feature === newPlanComparison.newFeatures[newPlanComparison.newFeatures.length - 2]"> {{ $t('functional.and') }} </span>
              </span>
              </template>
            </i18n>
          </p>
          <p>
            <i18n v-if="newPlanComparison.extraEnvelopes > 0" path="companySettings.billing.invoicePreview.yourExtraAllowance" tag="span">
              <template v-slot:allowance>
                <span>{{ newPlanComparison.extraEnvelopes }}</span>
              </template>
              <template v-slot:period>
                <span>{{ billingPeriod }}</span>
              </template>
            </i18n>
            <i18n v-else path="companySettings.billing.invoicePreview.yourNewAllowance" tag="span">
              <template v-slot:allowance>
                <span>{{ selectedPlan.allowance }}</span>
              </template>
              <template v-slot:period>
                <span>{{ billingPeriod }}</span>
              </template>
            </i18n>
            <i18n path="companySettings.billing.invoicePreview.yourOverages" tag="span">
              <template v-slot:overageSetting>
                <b class="boldDisplay"><span>{{ overageSetting }}</span></b>
              </template>
            </i18n>
            <!-- TODO There should have been a sentence about overage price here instead of below, but currently no endpoint returns that. I've written an issue to create an endpoint for it, so will need to come back and add sentence later. -->
            <a target="_blank" href="https://signable.help/what-happens-if-i-exceed-my-plan-limits-2/">{{ $t('companySettings.billing.invoicePreview.learnOverages') }}</a>
          </p>
        </div>
        <div slot="formButtons">
          <VButton
            type="cta-1"
            class="float-right"
            subtype="submit"
            data-ec="billing_plan_switch_success_modal"
            data-et="ok_button">
            <CheckIcon />
            <span>{{ $t('functional.okay') }}</span>
          </VButton>
        </div>
      </VForm>
  </ElDialog>
</template>

<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import VMessage from '@/components/deprecated/atoms/Message.vue';
import VLoadingSpinner from '@/components/deprecated/atoms/LoadingSpinner.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import { CheckIcon } from '@/components/icons/fontIcons';

export default {
  name: 'SwitchPlanInvoicePreviewModal',
  inject: {
    $validator: '$validator',
  },
  props: {
    show: Boolean,
    currentPlan: {
      type: [Object],
      required: false,
    },
    selectedPlan: {
      type: [Object],
      required: false,
    },
    isDowngrade: Boolean,
    overagesEnabled: Boolean,
  },
  data() {
    return {
      loading: false,
      featureLinks: {
        plan_api: 'https://signable.help/api-webhooks/',
        plan_allowlist: 'https://signable.help/what-is-the-ip-allowlist-feature-2/',
        plan_team: 'https://signable.help/what-is-the-users-teams-feature/',
        plan_branding: 'https://signable.help/video-tutorial-adding-your-branding-to-your-account-2/',
      },
      newPlanComparison: {
        newFeatures: [],
        extraEnvelopes: undefined,
      },
    };
  },
  components: {
    VButton,
    VForm,
    VLoadingSpinner,
    VMessage,
    CheckIcon,
  },
  computed: {
    successMessage() {
      return this.$t('companySettings.billing.invoicePreview.planSwitchSuccess', { plan: this.selectedPlan.nickname });
    },
    overageSetting() {
      return this.overagesEnabled ? this.$t('functional.enabled') : this.$t('functional.disabled');
    },
    billingPeriod() {
      return this.selectedPlan.interval === 'month' ? this.$t('companySettings.billing.plan.interval.month') : this.$t('companySettings.billing.plan.interval.year');
    },
  },
  methods: {
    modalOpened() {
      this.loading = true;
      this.getNewPlanComparison();
      this.loading = false;
    },
    getNewPlanComparison() {
        const oldSet = this.currentPlan.scope;
        const newSet = this.selectedPlan.scope;
        this.newPlanComparison.newFeatures = newSet.filter(feature => !oldSet.includes(feature));
        this.newPlanComparison.extraEnvelopes = this.selectedPlan.allowance - this.currentPlan.allowance;
    },
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.boldDisplay {
  display: inline-block !important;
}
.messageMargin {
  margin-top: 0 !important;
}
</style>
